import { render, staticRenderFns } from "./descriptive_balancedetails.vue?vue&type=template&id=56fdd004&"
import script from "./descriptive_balancedetails.vue?vue&type=script&lang=js&"
export * from "./descriptive_balancedetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports